var map = {
	"./add.svg": 281,
	"./books.svg": 419,
	"./call.png": 532,
	"./clock.png": 653,
	"./degree.mhtml": 734,
	"./degree.svg": 116,
	"./estar.png": 32,
	"./event.webp": 936,
	"./expert.svg": 614,
	"./fb.svg": 300,
	"./gel.png": 461,
	"./gelfin.jpg": 828,
	"./github.svg": 2,
	"./gmail.svg": 602,
	"./informed.svg": 149,
	"./insta.svg": 995,
	"./linkedin.svg": 657,
	"./paypal.jpg": 898,
	"./rightArrow.svg": 295,
	"./trust.png": 600,
	"./twitter.svg": 751,
	"./wp.svg": 288,
	"./yt.svg": 606
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;